import { CheckCircle2 } from "lucide-react";

export function StepIndicator({ step, currentStep, label }) {
  const done = currentStep > step;
  const active = currentStep === step;
  return (
    <div className={`flex items-center gap-3 p-3 rounded-xl transition-colors ${active ? "bg-[#1877F2]/5 border border-[#1877F2]/20" : done ? "bg-emerald-50 border border-emerald-100" : "bg-gray-50 border border-gray-100"}`}>
      <div className={`w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${done ? "bg-emerald-500 text-white" : active ? "bg-[#1877F2] text-white" : "bg-gray-200 text-gray-500"}`}>
        {done ? <CheckCircle2 className="w-4 h-4" /> : step}
      </div>
      <span className={`text-sm ${active ? "font-semibold text-gray-900" : done ? "text-emerald-700 font-medium" : "text-gray-500"}`}>{label}</span>
    </div>
  );
}
